/**
 * useAuth — 챗봇 초기화 hook
 *
 * 챗봇 마운트 시 /chatbot/api/init.jsp 호출하여
 * 인증 상태와 사용자 정보를 가져옵니다.
 */

import { useEffect } from 'react';
import { useAuthStore } from '@/stores/authStore';
import { fetchInit } from '@/lib/api/endpoints';

export function useAuth() {
  const setAuth = useAuthStore((s) => s.setAuth);
  const isInitialized = useAuthStore((s) => s.isInitialized);

  useEffect(() => {
    if (isInitialized) return;

    const currentPage = window.location.pathname;

    // 개발 환경: URL 쿼리 파라미터로 인증 상태 시뮬레이션
    if (import.meta.env.DEV) {
      const params = new URLSearchParams(window.location.search);
      const mockAuth = params.get('auth');

      if (mockAuth === 'user') {
        setAuth({
          status: 'authenticated',
          user: {
            id: 'user_demo_001',
            name: '홍길동',
            company: 'OO회사',
            user_type: '법인',
            plan: '후불제',
            joined_at: '2024-03-15',
          },
          context: { current_page: currentPage, page_meta: null },
          config: {
            operating_hours: { weekday: '09:00-18:00', timezone: 'Asia/Seoul' },
            is_operating_now: true,
            support_phone: '1544-9231',
          },
        });
        return;
      }

      // 기본: anonymous
      setAuth({
        status: 'anonymous',
        user: null,
        context: { current_page: currentPage, page_meta: null },
        config: {
          operating_hours: { weekday: '09:00-18:00', timezone: 'Asia/Seoul' },
          is_operating_now: true,
          support_phone: '1544-9231',
        },
      });
      return;
    }

    // 운영 환경: 실제 API 호출
    void (async () => {
      const res = await fetchInit(currentPage);

      if (res.success) {
        setAuth({
          status: res.data.auth_status,
          user: res.data.user,
          context: res.data.context,
          config: res.data.config,
        });
      } else {
        // 초기화 실패 시 anonymous로 진행
        setAuth({
          status: 'anonymous',
          user: null,
          context: { current_page: currentPage, page_meta: null },
          config: {
            operating_hours: { weekday: '09:00-18:00', timezone: 'Asia/Seoul' },
            is_operating_now: true,
            support_phone: '1544-9231',
          },
        });
      }
    })();
  }, [isInitialized, setAuth]);
}
